module.exports = __webpack_public_path__ + "img/bg17.7441dfff.png";